var _style, _circle, _path, _circle2, _path2, _circle3, _circle4, _path3, _circle5, _circle6, _path4, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllergies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "allergies_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".allergies_svg__st1{fill:var(--color-icon-secondary)}.allergies_svg__st2{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 73.7,
    fill: "none",
    stroke: "var(--color-text)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    r: 38.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "allergies_svg__st1",
    d: "M58 55.3c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zM74.6 45.6c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zM93.3 77.3c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zM55.3 84.8c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.7 4 4zM77.9 81.6c0 3.1-2.6 5.7-5.7 5.7s-5.7-2.6-5.7-5.7 2.6-5.7 5.7-5.7c3.2 0 5.7 2.5 5.7 5.7z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "allergies_svg__st1",
    cx: 81.1,
    cy: 59.3,
    r: 5.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "allergies_svg__st1",
    d: "M82.6 100.1c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zM101 56.9c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4c2.2-.1 4 1.7 4 4zM68.2 66.2c0 1.3-1.1 2.4-2.4 2.4s-2.4-1.1-2.4-2.4c0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "allergies_svg__st1",
    cx: 102,
    cy: 71,
    r: 2.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "allergies_svg__st1",
    cx: 95.4,
    cy: 90.3,
    r: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "allergies_svg__st1",
    d: "M64.6 96.8c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "allergies_svg__st1",
    cx: 48.9,
    cy: 70.1,
    r: 2.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "allergies_svg__st2",
    cx: 64,
    cy: 57,
    r: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "allergies_svg__st2",
    d: "M44.7 61.8c0 .1-.1.3-.3.3s-.3-.1-.3-.3c0-.1.1-.3.3-.3s.3.2.3.3zM20.3 57.8c0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3.2.1.3.2.3.3zM16.8 42.4c0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3.2.1.3.2.3.3zM32.5 28.6c0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3.2 0 .3.2.3.3zM53.5 22.3c0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3.1.1.3.2.3.3zM20.5 16.7c0 .1-.1.3-.3.3-.1 0-.2-.2-.2-.3 0-.1.1-.3.3-.3.1 0 .2.1.2.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "allergies_svg__st2",
    cx: 23.3,
    cy: 90.8,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "allergies_svg__st2",
    d: "M42.5 86c0-.1.1-.3.3-.3s.2.2.2.3-.1.3-.3.3-.2-.1-.2-.3zM67 90c0-.1.1-.3.3-.3.1 0 .3.1.3.3 0 .1-.1.3-.3.3-.2 0-.3-.1-.3-.3zM70.4 105.4c0-.1.1-.3.3-.3.1 0 .3.1.3.3 0 .1-.1.3-.3.3-.2 0-.3-.1-.3-.3zM54.7 119.2c0-.1.1-.3.3-.3.1 0 .3.1.3.3 0 .1-.1.3-.3.3s-.3-.1-.3-.3zM33.8 125.5c0-.1.1-.3.3-.3.1 0 .3.1.3.3 0 .1-.1.3-.3.3s-.3-.2-.3-.3zM66.7 131.2c0-.1.1-.3.3-.3.1 0 .3.1.3.3 0 .1-.1.3-.3.3-.2-.1-.3-.2-.3-.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "allergies_svg__st2",
    cx: 84.1,
    cy: 90.8,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "allergies_svg__st2",
    d: "M103.3 86c0-.1.1-.3.3-.3s.3.1.3.3c0 .1-.1.3-.3.3s-.3-.1-.3-.3zM127.8 90c0-.1.1-.3.3-.3.1 0 .3.1.3.3 0 .1-.1.3-.3.3-.2 0-.3-.1-.3-.3zM131.2 105.4c0-.1.1-.3.3-.3.1 0 .3.1.3.3 0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3zM115.6 119.2c0-.1.1-.3.3-.3.1 0 .3.1.3.3 0 .1-.1.3-.3.3s-.3-.1-.3-.3zM94.6 125.5c0-.1.1-.3.3-.3.1 0 .3.1.3.3 0 .1-.1.3-.3.3s-.3-.2-.3-.3zM127.5 131.2c0-.1.1-.3.3-.3.1 0 .3.1.3.3 0 .1-.1.3-.3.3-.2-.1-.3-.2-.3-.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "allergies_svg__st2",
    cx: 124.8,
    cy: 57,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "allergies_svg__st2",
    d: "M105.6 61.8c0 .1-.1.3-.3.3s-.3-.1-.3-.3c0-.1.1-.3.3-.3s.3.2.3.3zM77.7 42.4c0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3.2.1.3.2.3.3zM93.4 28.6c0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3.1 0 .3.2.3.3zM114.3 22.3c0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3.2.1.3.2.3.3zM81.4 16.7c0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3s.3.1.3.3z"
  }))));
}
export default SvgAllergies;